import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import 'dayjs/locale/en'
import { Calendar, Clock, MapPin, Activity } from 'react-feather'
import { t } from '@lingui/core/macro'

import { MeetingLinkOrder } from '@/core/graphql/types'
import { Card } from '@/components/ui/card'
import { useLocale } from '@/lib/next-shim'

import { getMeetingPlaceValue } from '../lib/orderLabels'
import { DetailItem } from './DetailItem'

export function AppointmentDetailsCard({ order }: { order: MeetingLinkOrder }) {
  const lang = useLocale()

  return (
    <Card className="bg-white rounded-2xl border-gray-200 p-6 shadow-sm">
      <div className="mb-6 flex items-center gap-2.5">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Calendar size={18} aria-hidden="true" />
        </span>
        <h3 className="text-lg font-semibold text-gray-900">{t`Appointment details`}</h3>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <DetailItem icon={<Calendar size={16} />} label={t`Date`} value={dayjs(order.startDate).locale(lang).format('dddd, D MMMM YYYY')} />
        <DetailItem icon={<Clock size={16} />} label={t`Time`} value={dayjs(order.startDate).format('HH:mm')} />
        <DetailItem icon={<MapPin size={16} />} label={t`Location`} value={getMeetingPlaceValue(order.meetingPlace)} />
        <DetailItem icon={<Activity size={16} />} label={t`Speciality`} value={order.speciality} />
      </div>
    </Card>
  )
}
